import { atom } from 'recoil';

const latestChangelogState = atom({
  key: 'latest-changelog',
  default: [],
});

export { latestChangelogState };
